import React from 'react';

const Play = () =>
	<svg width="47" height="47" viewBox="0 0 47 47">
		<path fill="#334849" fillRule="nonzero" d="M23.5,0 C10.5417083,0 0,10.5417083 0,23.5 C0,36.4582917 10.5417083,47 23.5,47 C36.4582917,47 47,36.4582917 47,23.5 C47,10.5417083 36.4582917,0 23.5,0 Z"/>
		<polygon fill="#FFF" points="17.625 33.292 17.625 13.708 33.292 23.5"/>
	</svg>;

export default Play;
